export const BREAKPOINTS = {
  laptop: "(max-width: 1600px)",
  desktop: "(min-width: 1601px)",
};